/* Fixed popup card in the bottom-right corner for both outage alerts and changelogs. */

import { AlertTriangle, X, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAnnouncements } from "@/hooks/useAnnouncements";

export function AnnouncementBanner() {
	const { announcements, dismiss } = useAnnouncements();

	if (!announcements || announcements.length === 0) return null;

	// Show outage alerts first, then most recent changelog
	const outage = announcements.find((a) => a.type === "outage");
	const changelog = announcements.find((a) => a.type === "changelog");
	const current = outage ?? changelog;

	if (!current) return null;

	const isOutage = current.type === "outage";

	return (
		<div className="fixed bottom-4 right-4 z-50 w-[340px] max-w-[calc(100vw-2rem)] animate-in slide-in-from-bottom-4 fade-in duration-300">
			<div className="rounded-xl border border-border bg-card shadow-lg">
				{/* Header */}
				<div className="flex items-start gap-3 px-4 pt-4 pb-2">
					{isOutage ? (
						<AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
					) : (
						<Sparkles className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
					)}
					<div className="flex-1 min-w-0">
						<p className={`font-semibold text-sm ${isOutage ? "text-destructive" : "text-foreground"}`}>
							{current.title}
						</p>
						<p className="text-muted-foreground text-xs mt-0.5">{current.message}</p>
					</div>
					<button
						onClick={() => dismiss(current._id)}
						className="shrink-0 rounded-md p-1 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
					>
						<X className="h-4 w-4" />
					</button>
				</div>

				{/* Changelog items */}
				{current.changelogItems && current.changelogItems.length > 0 && (
					<ul className="space-y-1.5 px-4 pb-2 text-xs">
						{current.changelogItems.map((item, i) => (
							<li key={i} className="flex items-start gap-2">
								{item.emoji && <span className="shrink-0">{item.emoji}</span>}
								<span className="text-muted-foreground">{item.text}</span>
							</li>
						))}
					</ul>
				)}

				{/* Footer with dismiss button */}
				<div className="border-t border-border px-4 py-2.5 space-y-1.5">
					{!isOutage && (
						<p className="text-[10px] text-muted-foreground text-center">
							You can find this later in Settings
						</p>
					)}
					<Button
						size="sm"
						variant={isOutage ? "outline" : "default"}
						className="w-full text-xs h-8"
						onClick={() => dismiss(current._id)}
					>
						{isOutage ? "Dismiss" : "Got it"}
					</Button>
				</div>
			</div>
		</div>
	);
}
